import _Vue from 'vue';
import { wxSdkInfo } from '@/api/api';
// 分享图片处理
function getCoverImage(post: any) {
  if (post.image) {
    return post.image;
  } else {
    return 'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
  }
}
// 获取微信sdk
function wxConfig(statement: object) {
  window.wx.config({
    debug: false,
    ...statement,
    jsApiList: [
      // 所有要调用的 API 都要加到这个列表中
      'updateAppMessageShareData', // 分享到朋友
      'updateTimelineShareData', // 分享到朋友圈
      'onMenuShareAppMessage',
      'onMenuShareTimeline',
    ],
  });
}
export default {
  install(Vue: typeof _Vue) {
    Vue.prototype.$wxShareInfo = (DetailsData: any) => {
      wxSdkInfo({ jssdkurl: window.location.href }).then((res: any) => {
        const data = res.data;
        // console.log(DetailsData);
        const e = DetailsData;

        const messageData = {
          title: e.title, // 分享标题
          desc: e.subtitle, // 分享描述
          link: e.url || location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: getCoverImage(e), // 分享图标
        };
        wxConfig(data);
        window.wx.ready(() => {
          window.wx.updateAppMessageShareData({
            ...messageData,
          });
          window.wx.updateTimelineShareData({
            ...messageData,
          });
        });
      });
    };
    console.log('启动wx分享成功');
  },
};
